import { SetObjectPropertyHelperBase } from './SetObjectPropertyHelperBase';
export class SetSymbolObjectPropertyHelper extends SetObjectPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getSymbolObject;
    }
    setDataProperty(sb) {
        return sb.helpers.setDataSymbolObjectProperty;
    }
}

//# sourceMappingURL=SetSymbolObjectPropertyHelper.js.map
